import SearchNoResult from "@website/accommodation-ui/villa-search/villa-search-panel/images/search-no-result.png";
import { useVillaSearchNoResult } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result/villa-search-no-result.hook";
import { VillaSearchNoResultPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result/villa-search-no-result.types";
import { LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const VillaSearchNoResult: FC<VillaSearchNoResultPropertiesType> = (
  properties
) => {
  const { resultTitle, notFoundtitle, firstDescription, secondDescription } =
    useVillaSearchNoResult(properties);

  return (
    <div className="my-6 flex flex-col items-center px-6">
      <div className="text-subtitle-2 text-on-surface-medium-emphasis w-full text-right">
        {resultTitle}
      </div>
      <LazyImage alt="no result" loading="eager" src={SearchNoResult.src} />
      <div className="text-subtitle-1 text-on-surface-high-emphasis mt-6">
        {notFoundtitle}
      </div>
      <div className="text-caption text-on-surface-medium-emphasis mt-2">
        {firstDescription}
      </div>
      <div className="text-caption text-on-surface-medium-emphasis mt-2">
        {secondDescription}
      </div>
    </div>
  );
};

const VillaSearchNoResultMemoized = memo(VillaSearchNoResult, deepCompare);
export { VillaSearchNoResultMemoized as VillaSearchNoResult };
